import React from 'react';
import { FaFacebook, FaInstagram, FaPinterest, FaTwitter } from 'react-icons/fa';
import Img from 'gatsby-image';
import { Link } from 'gatsby';
import Fade from 'react-reveal/Fade';

function Member({ data, management }) {
  const { image, name, position, about, memberType, twitter, instagram, pinterest } = data;
  return (
    <div className='team-member-container'>
      <Fade right>
        <div className={`team-member ${memberType === 'engineering' && 'eng'}`}>
          <div className='image-wrapper'>{image && image.fluid && <Img fluid={image.fluid} alt={name} />} </div>
          <div className='info'>
            <h3>{name}</h3>
            <h5>{position}</h5>
            <div dangerouslySetInnerHTML={{ __html: about?.childMarkdownRemark?.html }}></div>
          </div>
        </div>
      </Fade>
    </div>
  );
}

export default Member;
